<template>
  <transition name="toast-slide">
    <div v-if="goalToast" class="goal-toast" @click="dismiss">
      <div class="goal-toast-content">
        <span class="goal-icon">&#9917;</span>
        <div class="goal-text">
          <p class="goal-title">GOAL!</p>
          <p class="goal-score">
            {{ goalToast.homeTeam }} {{ goalToast.homeGoals }} - {{ goalToast.awayGoals }} {{ goalToast.awayTeam }}
            <span class="goal-minute">({{ goalToast.minute }}')</span>
          </p>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["goalToast"]),
  },
  watch: {
    goalToast(val) {
      if (val) {
        // Play goal sound
        try {
          let audio = new Audio("/s/success.ogg");
          audio.play();
        } catch (e) { /* ignore */ }
        // Auto dismiss after 6 seconds
        setTimeout(() => this.dismiss(), 6000);
      }
    },
  },
  methods: {
    dismiss() {
      this.$store.commit("clearGoalToast");
    },
  },
};
</script>

<style scoped>
.goal-toast {
  position: fixed;
  top: 1rem;
  right: 1rem;
  z-index: 9999;
  cursor: pointer;
  animation: pulse 0.3s ease-out;
}
.goal-toast-content {
  display: flex;
  align-items: center;
  background: linear-gradient(135deg, #1d9c2a 0%, #16a34a 100%);
  color: white;
  padding: 1rem 1.5rem;
  border-radius: 1rem;
  box-shadow: 0 8px 24px rgba(29, 156, 42, 0.4);
  min-width: 280px;
}
.goal-icon {
  font-size: 2rem;
  margin-right: 0.75rem;
}
.goal-title {
  font-weight: 800;
  font-size: 1.1rem;
  letter-spacing: 0.05em;
}
.goal-score {
  font-size: 0.9rem;
  opacity: 0.95;
}
.goal-minute {
  opacity: 0.7;
  font-size: 0.8rem;
}
@keyframes pulse {
  0% { transform: scale(0.8); opacity: 0; }
  50% { transform: scale(1.05); }
  100% { transform: scale(1); opacity: 1; }
}
.toast-slide-enter-active { animation: pulse 0.3s ease-out; }
.toast-slide-leave-active { transition: all 0.3s ease-in; }
.toast-slide-leave-to { transform: translateX(120%); opacity: 0; }
</style>
